module.exports = __webpack_public_path__ + "img/map.f0dc2337.jpg";